<template>
  <SurveyInsightsLoader v-if="loading" />
  <div v-else-if="!showOverlay" class="survey-insights-grid">
    <GenderDistributionChart class="gender-distribution" />
    <GenderByStageChart class="gender-by-stage" />
    <RacialDistributionChart class="race-distribution" />
    <RaceByStageChart class="race-by-stage" />
    <GenderAndRaceTable class="gender-and-race-table" />
  </div>
  <div v-else class="survey-insights-overlay">
    <img src="@/assets/no-permission-demographic.png" alt="Demographic Survey Report Placeholder" />
    <LowDataModal
      :model-value="isLowData && canDemographicSurveyReport"
      @update:view-data-anyway="$emit('update:viewDataAnyway')"
      @update:is-survey-insights-tab="$emit('update:isSurveyInsightsTab', $event)"
    />
    <NoPermissionsModal
      :model-value="!canDemographicSurveyReport"
      @update:is-survey-insights-tab="$emit('update:isSurveyInsightsTab', $event)"
    />
  </div>
</template>

<script setup>
import GenderDistributionChart from '@/components/insights/ProcessInsights/DemographicSurveyReport/charts/GenderDistributionChart.vue';
import RacialDistributionChart from '@/components/insights/ProcessInsights/DemographicSurveyReport/charts/RacialDistributionChart.vue';
import GenderByStageChart from '@/components/insights/ProcessInsights/DemographicSurveyReport/charts/GenderByStageChart.vue';
import RaceByStageChart from '@/components/insights/ProcessInsights/DemographicSurveyReport/charts/RaceByStageChart.vue';
import GenderAndRaceTable from '@/components/insights/ProcessInsights/DemographicSurveyReport/tables/GenderAndRaceTable.vue';
import LowDataModal from '@/components/insights/ProcessInsights/DemographicSurveyReport/modals/LowDataModal.vue';
import { computed } from 'vue';
import NoPermissionsModal from '@/components/insights/ProcessInsights/DemographicSurveyReport/modals/NoPermissionsModal.vue';
import SurveyInsightsLoader from '@/components/insights/ProcessInsights/DemographicSurveyReport/skeletonLoaders/SurveyInsightsLoader.vue';

const props = defineProps({
  isLowData: { type: Boolean, default: false },
  canDemographicSurveyReport: { type: Boolean, default: false },
  optedToViewDataAnyway: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
});

defineEmits(['update:isSurveyInsightsTab', 'update:viewDataAnyway']);

const showOverlay = computed(() => (props.isLowData || !props.canDemographicSurveyReport)
  && !props.optedToViewDataAnyway);
</script>

<style scoped lang="less">
.survey-insights-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(400px, 470px) minmax(420px, 1fr);
  grid-template-rows: 385px 385px auto;
}

.gender-distribution {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
}

.gender-by-stage {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
}

.race-distribution {
  grid-column: 1 / 2;
  grid-row: 2 / 3;
}

.race-by-stage {
  grid-column: 2 / 3;
  grid-row: 2 / 3;
}

.gender-and-race-table {
  grid-column: span 2;
  grid-row: 3 / 4;
  min-height: 228px;
}

.survey-insights-overlay {
  width: 100%;

  img {
    width: 100%;
  }
}
</style>
